function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.55546 8.44454C6.03973 7.92882 5.75 7.22935 5.75 6.5C5.75 5.77065 6.03973 5.07118 6.55546 4.55546C7.07118 4.03973 7.77065 3.75 8.5 3.75C9.22935 3.75 9.92882 4.03973 10.4445 4.55546C10.9603 5.07118 11.25 5.77065 11.25 6.5C11.25 7.22935 10.9603 7.92882 10.4445 8.44454C9.92882 8.96027 9.22935 9.25 8.5 9.25C7.77065 9.25 7.07118 8.96027 6.55546 8.44454Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 5H18",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 8H17",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.12247 11.75H9.87593C12.3796 11.75 14.2486 13.5246 14.25 15.5186C14.2498 15.8372 13.9243 16.25 13.3202 16.25H3.67984C3.07486 16.25 2.75 15.8364 2.75 15.5183C2.75 13.5245 4.61574 11.75 7.12247 11.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/profile.1f7d2859.svg";
export { SvgComponent as ReactComponent };